module.exports = __webpack_public_path__ + "9d09ceba.svg";